/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

export interface TdSideBarProps {
  /**
   * 选项值
   */
  value?: {
    type: null;
    value?: string | number;
  };
  /**
   * 选项值，非受控属性
   */
  defaultValue?: {
    type: null;
    value?: string | number;
  };
}
